import React from 'react';
import {FaBell} from "react-icons/fa";
import IconButtonStyled from "../../../styled/IconButton";


const NotificationBell = ({number = 0, clickHandle})=> {

    return (
        <IconButtonStyled onClick={clickHandle} fontSize="1.5rem" color='#6FCBD1' $badgeBg={number > 0 ? '#e02424' : undefined}>
            {number > 0 && <span>{number}</span>}
            <FaBell/>
        </IconButtonStyled>
    )

}

export default NotificationBell